import { useState } from "react";
import useMerchantPortalAxios from "../utils/axios";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";

const SalesTransactionsAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const [salesTransactions, setSalesTransactions] = useState([]);
    const [totalNbOfPage, SetTotalNbOfPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [salesLoading, setSalesLoading] = useState(false);

    const [availableBalances, setAvailableBalances] = useState([]);
    const [balancesLoading, setBalancesLoading] = useState(false);
    const [exportTSData, setExportTSData] = useState(null);

    async function GetSalesTransactions(CurrencyID , pageNb ,dateFrom, dateTo, transactionType) {
        setSalesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetSalesTransactions`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType
            }
        ).then((res) => {
            setSalesTransactions(res.data.Payload.SalesTransactions);
            if (res.data.Payload.SalesTransactions?.length===0){
                SetTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                SetTotalNbOfPage(res.data.Payload.SalesTransactions[0].TotalPages);
                setTotalCount(res.data.Payload.SalesTransactions[0].TotalCount);
            }
            setSalesLoading(false);
        })
    }

    async function GetAvailableSalesAndBalance() {
        const req = new BaseRequest(sessionStorage.getItem("SessionID"));
        setBalancesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetAvailableSalesAndBalance`,
            req
        ).then((res) => {
            setAvailableBalances(res.data.Payload.AvailableSalesBalances);
            setBalancesLoading(false);
        });
    }

    async function getSTExport(CurrencyID ,dateFrom, dateTo, transactionType) {
        setSalesLoading(true);
        await MerchantPortalAxios.post(
            `/v1/Sales/GetSalesTransactions`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                CurrencyID: CurrencyID,
                page: 1,
                pageSize: 1,
                DateFrom: dateFrom,
                DateTo: dateTo,
                TransactionType: transactionType,
                isExport: true
            }
        ).then((res) => {
            setExportTSData(res.data.Payload.SalesTransactions);
        })
    }


    return {
        GetSalesTransactions,
        GetAvailableSalesAndBalance,
        salesTransactions,
        totalNbOfPage,
        totalCount,
        salesLoading,
        availableBalances,
        balancesLoading,
        getSTExport,
        exportTSData,
        setExportTSData
    };
};

export default SalesTransactionsAPI;
